<template>
    <div class="container">
         <div class="box">
             <div class="box_top">
                 <div class="status line_bottom">
                        <p class="title">{{item.defendant_name}}</p>
                        <div class="item">
                                <p>回访评价：</p>
                                <p class="tip_two" v-if="dataList.statue==10" style="color:#36B374;">{{dataList.returnVisitScore|filt4}}</p>
                                <p v-if="dataList.statue==1">{{dataList.statueValue}}</p>
                                <p v-if="dataList.statue==20">回访失败</p>
                        </div>
                        <div class="item item1">
                                <p>回访时间：</p>
                                <p >{{dataList.returnVisitTime}}</p>
                                <!-- <p v-if="dataList.statue==1">回访未开始</p> -->
                        </div>
                        <div class="item item1">
                                <p>生成时间：</p>
                                <p >{{dataList.createTime}}</p>
                                <!-- <p v-if="dataList.statue!=1">{{dataList.original_evaluate_time}}</p> -->
                                <!-- <p v-if="dataList.statue==1">回访未开始</p> -->
                        </div>
                        <p class="wait" v-if="dataList.statue==20">回访失败</p>
                        <p class="wait" v-if="dataList.statue==1">{{dataList.statueValue}}</p>
                   </div>
                   <!-- <div class="status line_bottom" v-if="dataList.statue==1">
                        <p class="title">阳宗海大酒店</p>
                        <div class="item">
                                <p>回访评价：</p>
                                <p class="tip_two">回访未开始</p>
                        </div>
                        <div class="item item1">
                                <p>回访时间：</p>
                                <p>回访未开始</p>
                        </div>
                        <div class="item item1">
                                <p>生成时间：</p>
                                <p>回访未开始</p>
                        </div>
                        <p class="wait">待回访</p>
                   </div> -->
                   <!-- <div class="status line_bottom" v-if="dataList.statue==20">
                        <p class="title">阳宗海大酒店</p>
                        <div class="item">
                                <p>回访评价：</p>
                                <p class="tip_two">回访失败</p>
                        </div>
                        <div class="item item1">
                                <p>回访时间：</p>
                                <p>回访失败</p>
                        </div>
                        <div class="item item1">
                                <p>生成时间：</p>
                                <p>回访失败</p>
                        </div>
                        <p class="wait">回访失败</p>
                   </div> -->
                   <div class="returnContent">
                         <p class="title">回访诉求</p>
                         <div class="content">
                             <p class="text" v-if="dataList.statue==10">{{dataList.returnVisitRequest}}</p>
                             <div class="nocontent" v-if="dataList.statue!=10">
                                 <img src="../../../../../assets/image/Group.png"/>
                                 <p>回访结束后，游客回访诉求会在这里显示哦</p>
                             </div>
                         </div>
                   </div>
             </div>
         </div>
         <div class="box_bottom">
            <p class="title">原投诉单信息</p>
            <div class="box_item box_one">
                <p>投诉人: </p>
                <p>{{item.complainName}}</p>
            </div>
            <div class="box_item">
                <p>投诉时间: </p>
                <p>{{item.complainTime}}</p>
            </div>
            <div class="box_item">
                <p>投诉单号: </p>
                <p>{{item.mainComplainNumber}} </p>
            </div>
            <div class="detail" @click="goDetail" v-if="!fromType">
                 <p>投诉详情</p>
                 <img src="../../../../../assets/image/right.png"/>
            </div>
         </div>
    </div>
</template>
<script>
    import api from '../../../../../service/modules/complaintApis';
    import util from '@/utils/common'
    export default {
        data () {
            return {
                dataList: '',
                fromType: this.$route.query.fromType,
                item: util.getJsonLocal('item') // 上页面列表数据
            }
        },
        created () {
            this.getDetail();
            console.log('this.$route.query:', this.$route.query);
        },
        methods: {
            goDetail () {
                this.$store.commit('complaint/setKey', 'returnDetail');
                this.$router.push({
                    name: 'workListDetails',
                    query: { fromType: 'returnDetail' }
                });
            },
            async getDetail () {
                const data = {
                    mainComplainNumber: this.item.mainComplainNumber,
                    complainNumber: this.item.complainNumber,
                    type: 'returnVisitDetails'
                }
                let result = {};
                if (this.$route.query.type === 'assess') {
                    result = await api.returnAssessDetail(data);
                } else {
                    result = await api.common.queryDetailInfo({data});
                }
                if (result.errorcode === 0) {
                    this.dataList = result.data.returnVisitDetails;
                    console.log(this.dataList);
                }
            }
        },
        filters: {
            filt4 (value) {
                if (value == 3) {
                    return '满意'
                } else if (value == 2) {
                    return '基本满意'
                } else if (value == 1) {
                    return '不满意'
                }
            }
        }
    }
</script>
<style scoped lang="less">
.container{
    width:100%;
    height:100vh;
    padding:16px 12px;
    box-sizing: border-box;
    background-color: #FBFBFB;
    .box{
        width:100%;
        background-color: #fff;
        border-radius: 3px;
        .box_top{
            width:100%;
            padding:16px 0 21px 0;
            box-sizing: border-box;
          .status{
                width:100%;
                padding: 0 16px 16px 16px;
                box-sizing: border-box;
                position: relative;
                .title{
                    font-size:14px;
                    color:#2A2A2A;
                }
                .item{
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    margin-top:16px;
                    p:nth-child(1){
                        width:70px;
                        font-size:14px;
                        color:#999999;
                    }
                    p:nth-child(2){
                        font-size:14px;
                        color:#999999;
                        margin-left:16px;
                    }
                    .tip_two{
                        color:#36B374
                    }
                }
                .item1{
                    margin-top:12px;
                }
                .wait{
                    position: absolute;
                    right:16px;
                    top:0px;
                    font-size:12px;
                    color:#FF8C19;
                }
           }
           .returnContent{
               width:100%;
               min-height: 115px;
               padding: 16px 16px 0px 16px;
               box-sizing: border-box;
               .title{
                   font-size:14px;
                   color:#2A2A2A;
               }
               .content{
                   width:100%;
                //    margin-top:14px;
                   .text{
                       font-size:14px;
                       color:#666666;
                       line-height: 1.3em;
                       margin-top:16px;
                   }
                   .nocontent{
                       width:100%;
                       text-align: center;
                       margin-top:24px;
                       img{
                           width:28px;
                           height:30px;
                           display: inline-block;
                       }
                       p{
                           font-size:12px;
                           color:#999;
                           margin-top:17px;
                       }
                   }

               }
           }
        }
    }
    .box_bottom{
        width:100%;
        padding:16px;
        box-sizing: border-box;
        margin-top:20px;
        background-color: #fff;
        border-radius: 3px;
        .title{
            color:#2A2A2A;
            font-size:14px;
            padding-bottom: 16px;
        }
        .box_item{
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-top:12px;
            p:nth-child(1){
                width:70px;
                font-size:14px;
                color:#999;
            }
            p:nth-child(2){
                margin-left:16px;
                font-size:14px;
                color:#666;
            }
        }
        .box_one{
            margin-top:0;
        }
        .detail{
            width:100%;
            text-align: center;
            padding-top:10px;
            margin-top:23px;
            p{
                font-size:12px;
                color:#9B9B9B;
                display: inline-block;
                vertical-align: middle;
            }
            img{
                width:4px;
                height:7px;
                display: inline-block;
                vertical-align: middle;
                margin-left:6px;
            }
        }
    }
}
</style>
